import { createClient, type SupabaseClientOptions } from "@supabase/supabase-js";

import { getEnv } from "@/hooks/useEnv";

import type { Database } from "@/supabase.types";

const clientOptions: SupabaseClientOptions<"public"> = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit",
  },
};

const apiClient = createClient<Database>(
  getEnv("VITE_SUPABASE_URL") ?? "",
  getEnv("VITE_SUPABASE_KEY") ?? "",
  clientOptions,
);

export default apiClient;
